import type { NodeTypes } from '@mv/core/model/heim/richText';
import type { ReactNode } from 'react';
import type { RichTextContext, RichTextRenderers } from '../RichText';
import { CtaTiles, type CtaTilesFields } from './CtaTiles';
import { MediaBlock, type MediaBlockFields, type RenderNodes } from './MediaBlock';

export function renderBlock(
	node: NodeTypes,
	key: number,
	context: RichTextContext,
	renderers: RichTextRenderers | undefined,
	children: ReactNode,
	renderNodes: RenderNodes,
) {
	const fields = node.fields as MediaBlockFields | CtaTilesFields | undefined;

	if (fields?.blockType === 'mediaBlock') {
		return <MediaBlock key={key} fields={fields} context={context} renderers={renderers} renderNodes={renderNodes} />;
	}
	if (fields?.blockType === 'ctaTiles') return <CtaTiles key={key} fields={fields} context={context} />;

	return renderers?.unknown?.(node, children, key, context) ?? children;
}
